console.log('custom JS installed');

 document.addEventListener("DOMContentLoaded", function() {
      const videos = document.querySelectorAll("video[data-lazy]");
      videos.forEach(video => {
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              video.querySelectorAll("source").forEach(srcEl => {
                if (srcEl.dataset.src) {
                  srcEl.src = srcEl.dataset.src;
                  srcEl.removeAttribute("data-src");
                }
              });
              video.load();
              video.play().catch(()=>{});
              obs.unobserve(video);
            }
          });
        }, { threshold: 0.25 });
        observer.observe(video);
      });
    });



    document.addEventListener("DOMContentLoaded", function() {
  const desktopVideo = document.getElementById("hero-video-desktop");
  const mobileVideo  = document.getElementById("hero-video-mobile");
  if (!desktopVideo || !mobileVideo) return;

  function loadMobileSources() {
    const isMobile = window.matchMedia("(max-width: 1200px)").matches;
    if (isMobile && mobileVideo.childElementCount === 0) {
      desktopVideo.querySelectorAll("source").forEach(src => {
        mobileVideo.appendChild(src.cloneNode());
      });
      mobileVideo.load();
    }
  }

  // Beim Start + bei Resize prüfen
  loadMobileSources();
  window.addEventListener("resize", loadMobileSources);
});